import {Icon} from '@hm/fundamental'
import {mdiChevronDown} from '@mdi/js'
import {useState, useId, useEffect} from 'react'

import {useFiltersCollapse} from './FiltersCollapseProvider'

export interface CollapsibleFilterWrapperProps {
  title: React.ReactNode
  defaultOpen?: boolean
  children: React.ReactNode
  rightSlot?: React.ReactNode
  'data-cy'?: string
}

export const CollapsibleFilterWrapper: React.FC<CollapsibleFilterWrapperProps> = ({
  title,
  defaultOpen = true,
  children,
  rightSlot,
  'data-cy': dataCy
}) => {
  const [open, setOpen] = useState(defaultOpen)
  const contentId = useId()
  const collapseContext = useFiltersCollapse()

  useEffect(() => {
    if (collapseContext) {
      setOpen(!collapseContext.allCollapsed)
    }
  }, [collapseContext, collapseContext?.allCollapsed, collapseContext?.collapseVersion])

  return (
    <div data-cy={dataCy}>
      <div className="flex items-center justify-between">
        <div className="flex flex-row gap-2 items-center">
          <button
            className="flex items-center justify-center p-1 rounded-full cursor-pointer border-none bg-transparent hover:bg-gray-100 transition-transform duration-200"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-controls={contentId}
            style={{transform: open ? 'rotate(0deg)' : 'rotate(180deg)'}}
          >
            <Icon path={mdiChevronDown} />
          </button>
          <div className="font-medium">{title}</div>
        </div>
        <div className="flex items-center gap-2">{rightSlot}</div>
      </div>

      {open && (
        <div id={contentId} className="p-2">
          {children}
        </div>
      )}
    </div>
  )
}
